import { MatOption } from '@angular/material/core';

/** Host element for a Material list option (stable across MDC mat-option versions). */
export function getMatOptionHostElement(option: MatOption): HTMLElement | null {
  const withHost = option as unknown as { _getHostElement?: () => HTMLElement };
  if (typeof withHost._getHostElement === 'function') {
    return withHost._getHostElement();
  }
  const withRef = option as unknown as {
    _elementRef?: { nativeElement: HTMLElement };
  };
  return withRef._elementRef?.nativeElement ?? null;
}

/**
 * Move DOM focus into the listbox on the given option so mobile screen readers
 * (TalkBack / VoiceOver) enter the panel without an extra touch on the list.
 */
export function focusMatOptionElement(option: MatOption): boolean {
  const host = getMatOptionHostElement(option);
  if (!host) {
    return false;
  }
  if (!host.hasAttribute('tabindex')) {
    host.setAttribute('tabindex', '-1');
  }
  host.focus({ preventScroll: true });
  return document.activeElement === host;
}
